import { getMixpanelClient } from '@/plugins/analyticsClients'
import type { Mixpanel } from '@/plugins/mixpanel'

/**
 * Returns the Mixpanel instance when the plugin is installed.
 * Mixpanel is used for session replay and identity only — not as an event sink.
 * Events go through useAnalytics() → Segment + Customer.io.
 */
export const useMixpanel = (): Mixpanel | undefined => {
  return getMixpanelClient()
}
